import gql from 'graphql-tag'

export const CREATE_ACCOUNT_MUTATION = gql`
  mutation CreateAccount($email: String!, $password: String!, $firstName: String!, $lastName: String!) {
    createAccount(email: $email, password: $password, firstName: $firstName, lastName: $lastName) {
      id
      email
      firstName
      lastName
    }
  }
`

export const USER_REGISTER_MUTATION = gql`
  mutation UserRegister($input: UserRegisterInput!) {
    userRegister(input: $input) {
      token
      user {
        id
        email
        firstName
        lastName
      }
      errors
    }
  }
`

export interface UserRegisterResponse {
  userRegister: {
    token: string;
    user: {
      id: string;
      email: string;
    };
    errors: string[];
  };
}

export interface UserRegisterVariables {
  input: {
    email: string;
    password: string;
    passwordConfirmation: string;
    firstName: string;
    lastName: string;
  };
}

export const SUBMIT_EARLY_ACCESS_FORM_MUTATION = gql`
  mutation SubmitEarlyAccessForm($input: EarlyAccessFormInput!) {
    submitEarlyAccessForm(input: $input) {
      success
      message
    }
  }
`

export interface EarlyAccessFormResponse {
  submitEarlyAccessForm: {
    success: boolean
    message: string
  }
}

export interface EarlyAccessFormVariables {
  input: {
    email: string
    firstName: string
    lastName: string
    company: string
    state: string
    projects: string
    recaptchaToken: string
  }
}

export const USER_LOGOUT_MUTATION = gql`
  mutation UserLogout($input: UserLogoutInput!) {
    userLogout(input: $input) {
      success
      errors
    }
  }
`

export interface UserLogoutResponse {
  userLogout: {
    success: boolean
    errors: string[] | null
  }
}

export interface UserLogoutVariables {
  input: {
    dummy?: string
  }
}
